import { render, staticRenderFns } from "./VCoinSendModal.vue?vue&type=template&id=3fad1939&scoped=true"
import script from "./VCoinSendModal.vue?vue&type=script&lang=ts"
export * from "./VCoinSendModal.vue?vue&type=script&lang=ts"
import style0 from "./VCoinSendModal.vue?vue&type=style&index=0&id=3fad1939&prod&lang=scss&scoped=true"
import style1 from "./VCoinSendModal.vue?vue&type=style&index=1&id=3fad1939&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fad1939",
  null
  
)

export default component.exports